import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';

lightGallery(document.getElementById('lightgallery'), {
	plugins: [lgZoom, lgVideo],
	licenseKey: '0000-0000-000-0000',
	speed: 500,
	mode: 'lg-fade',
	getCaptionFromTitleOrAlt: false,
	download: false,
	mobileSettings: { controls: false, showCloseIcon: true, download: false },
});

// measurement converter
jQuery('#cmm').bind('keypress keydown keyup',function(){
	var acho = parseFloat(jQuery('#cmm').val());

	var v = '';
	var i = '';
	var vResult = '';
	var iResult = '';
	if (!isNaN(acho)){
		v = (acho * 30.84);
		vResult = v.toFixed(2);
		i = (acho * 12);
		iResult = i.toFixed(2);
	}
	var vResString = vResult.toString();
	var iResString = iResult.toString();
	// jQuery('#resultFeet').val(vResult.toString());
	// jQuery('#resultInches').val(iResString);
	jQuery( '#resultFeet' ).val( function( index, val ) {
			console.log(val);
			return vResString + ' cm';
	});
	jQuery( '#resultInches' ).val( function( index, val ) {
			console.log(val);
			return iResString + ' in';
	});
});
jQuery('#resultFeet').bind('keypress keydown keyup',function(){
	var acho = parseFloat($('#resultFeet').val());

	var v = '';
	var i = '';
	var vResult = '';
	var iResult = '';
	if (!isNaN(acho)){
		v = (acho * 0.032808399);
		vResult = v.toFixed(2);
		i = (acho * 0.393700787);
		iResult = i.toFixed(2);
	}

	var vResString = vResult.toString();
	var iResString = iResult.toString();
	// jQuery('#cmm').val(vResult.toString());
	// jQuery('#resultInches').val(iResult.toString());
	jQuery( '#cmm' ).val( function( index, val ) {
			console.log(val);
		return vResString + ' ft';
	});
	jQuery( '#resultInches' ).val( function( index, val ) {
			console.log(val);
		return iResString + ' in';
	});
});
jQuery('#resultInches').bind('keypress keydown keyup',function(){
	var acho = parseFloat($('#resultInches').val());

	var v = '';
	var i = '';
	var vResult = '';
	var iResult = '';
	if (!isNaN(acho)){
		v = (acho * 0.0833333333);
		vResult = v.toFixed(2);
		i = (acho * 2.54);
		iResult = i.toFixed(2);
	}

	var vResString = vResult.toString();
	var iResString = iResult.toString();
	// jQuery('#cmm').val(vResult.toString());
	// jQuery('#resultFeet').val(iResult.toString());
	jQuery( '#cmm' ).val( function( index, val ) {
			console.log(val);
		return vResString + ' ft';
	});
	jQuery( '#resultFeet' ).val( function( index, val ) {
			console.log(val);
		return iResString + ' cm';
	});
});



// WEBPACK FOOTER //
// ./scripts/single-product.js